module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-summer-2000.d0f4fe55.svg";